<template>
    <div id="street">
        <div @click="visible = true">
            <slot name="selected" :data="value[0]">
            </slot>
        </div>
        <Popup v-model="visible" position="bottom">
            <Area
                title="街乡"
                :columns-num="1"
                :columns-placeholder="['请选择']"
                :areaList="areaList"
                @confirm="handleConfirm"
                @cancel="hide"
            />
        </Popup>
    </div>
</template>

<script>
// components
import { Area, Popup } from 'vant'
import * as config from './config'

export default {
    props: {
        value: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    components: {
        Area,
        Popup,
    },
    data () {
        return {
            visible: false,
            ...config
        }
    },
    methods: {
        show () {
            this.visible = true
        },
        hide () {
            this.visible = false
        },
        handleConfirm (value) {
            this.$emit('confirm', value[0])
            this.hide()
        }
    }
}
</script>